import styled from '@emotion/styled'
import { ModalContent } from 'view/components/panels'
import { SearchInput } from 'view/components/inputs'
import { RemoveItemButton } from 'view/components/options/optionsStyles'
import * as constants from 'view/styles/constants'
import { Dropzone } from '../upload'
import { SplitButtonDropdown } from 'view/components/menus'

export const OpenFinWindow = styled.div`
  display: flex;
  flex-direction: column;
`

export const OpenFinDropzone = styled(Dropzone)`
  height: calc(100% - 38px);
  flex-direction: column;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  small {
    font-size: 12px;
    font-weight: normal;
    display: inline-block;
    margin-left: 10px;
  }
`

export const Timer = styled.div`
  margin: 0 5px;
`

export const Content = styled(ModalContent)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
  margin: 0 24px;
  width: 1220px;
  min-height: 500px;
  border-bottom: 1px solid ${constants.CORE_PRIMARY_1};
`

export const TabbedContent = styled.div`
  margin-top: 15px;
`

export const DetailsContainer = styled.section`
  width: 340px;
`

export const AllocationContainer = styled.section`
  width: 860px;
`

export const Heading = styled.h5`
  font-size: 13px;
  color: #404040;
  font-weight: normal;
  margin: 15px 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const SearchBar = styled(SearchInput)`
  margin-right: 5px;
`

export const ScrollContainer = styled.div<{ maxHeight: number; maxWidth?: number }>`
  max-height: ${props => props.maxHeight}px;
  overflow-y: auto;
  padding-right: 5px;

  ${props =>
    props.maxWidth &&
    `
    max-width: ${props.maxWidth}px;
    overflow-x: auto;
  `}
`

export const NoEntities = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${constants.CORE_PRIMARY_4};
`

export const AvailableTable = styled.table`
  border-collapse: collapse;
  min-width: 100%;

  th,
  td {
    text-align: left;
    padding: 7px 5px;
    color: ${constants.CORE_PRIMARY_6};
  }

  thead {
    th {
      position: sticky;
      top: 0;
      z-index: 2;
      font-weight: normal;
      color: ${constants.CORE_PRIMARY_6};
      font-size: 11px;
      background: ${constants.CORE_PRIMARY};

      :first-child {
        padding-left: 10px;
      }
    }
  }

  tbody {
    border-radius: 5px;
    box-shadow: 2px 0px 0px 0px ${constants.CORE_PRIMARY_1};
    background: linear-gradient(to top, ${constants.CORE_PRIMARY_1} 2px, transparent 3px);

    tr {
      background: linear-gradient(to bottom, ${constants.CORE_PRIMARY_1} 2px, transparent 2px);

      td {
        :first-child {
          background: linear-gradient(to right, ${constants.ACCENT_PRIMARY} 5px, transparent 5px);
          padding-left: 10px;
          font-weight: bold;
        }

        :last-child {
          display: flex;
          justify-content: flex-end;
        }
      }

      :first-child {
        td {
          :first-child {
            border-top-left-radius: 5px;
          }
          :last-child {
            border-top-right-radius: 5px;
          }
        }
      }

      :last-child {
        td {
          :first-child {
            border-bottom-left-radius: 5px;
          }
          :last-child {
            border-bottom-right-radius: 5px;
          }
        }
      }
    }
  }
`

const Amount = styled.div`
  padding: 0px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
`

export const Required = styled(Amount)<{ fullyAllocated?: boolean }>`
  padding: 4px 10px;
  background-color: ${constants.ACCENT_PRIMARY};
  color: ${constants.CORE_PRIMARY};
  border-radius: 5px;
  ${props =>
    props.fullyAllocated &&
    `
     border-radius: 5px 5px 0px 5px;
    `}
`

export const Allocated = styled(Amount)<{ fullyAllocated?: boolean }>`
  font-weight: bold;
  color: ${constants.CORE_PRIMARY_6};
  margin-top: -1px;
  ${props =>
    props.fullyAllocated &&
    `
      padding-right: 0;
    `}
`

export const AllocatedValue = styled.span<{ fullyAllocated?: boolean }>`
  padding: 5px 0;
  display: inline-block;
  ${props =>
    props.fullyAllocated &&
    `
     padding: 5px 10px;
     background: ${constants.ACCENT_PRIMARY};
     border-radius: 0px 0px 5px 5px;
     color: ${constants.CORE_PRIMARY};
    `}
`

export const Remaining = styled(Amount)<{ overAllocated?: boolean }>`
  color: ${props => (props.overAllocated ? constants.ACCENT_BAD : constants.CORE_PRIMARY_4)};
  font-weight: normal;
`

export const HaircutTypeWrapper = styled(Amount)`
  padding: 10px 10px 0;
  font-weight: normal;
`

export const AllocationTable = styled.table`
  border-collapse: separate;
  border-spacing: 0 5px;

  th,
  td {
    padding: 7px 5px;
    text-align: right;

    color: ${constants.CORE_PRIMARY_6};
    :nth-child(-n + 3) {
      text-align: left;
    }
  }

  thead {
    th {
      text-align: left;
      position: sticky;
      top: 0;
      z-index: 2;
      background: ${constants.CORE_PRIMARY};
      font-weight: normal;

      font-size: 11px;
      padding: 0 5px;

      :first-child {
        padding-left: 10px;
      }
    }
  }

  tbody {
    tr {
      background-color: ${constants.CORE_PRIMARY_1};

      td {
        border-top: 1px solid ${constants.CORE_PRIMARY_2};
        border-bottom: 1px solid ${constants.CORE_PRIMARY_2};
        white-space: no-wrap;

        :first-child {
          padding-left: 10px;
          font-weight: bold;
          border-left: 5px solid ${constants.ACCENT_PRIMARY};
        }

        :last-child {
          border-right: 1px solid ${constants.CORE_PRIMARY_2};
          background-color: ${constants.CORE_PRIMARY};
          padding: 0;
          width: 24px;
        }
      }
    }
  }
`

export const FillOrTrimContainer = styled.div`
  display: flex;
`

export const FillOrTrimButton = styled(RemoveItemButton)`
  svg {
    width: 24px;
    height: 24px;
  }
  &:hover {
    svg {
      color: ${constants.ACCENT_PRIMARY};
    }
  }
`

export const RemoveAllocationButton = styled(RemoveItemButton)`
  svg {
    width: 12px;
    height: 12px;
  }
`

export const FundAssignmentUploadDropzone = styled(Dropzone)`
  flex-direction: column;
`

export const UploadCollateralAllocationsButton = styled(SplitButtonDropdown)`
  margin-left: 10px;
  width: 175px;
`
